export default __webpack_public_path__ + "static/mountains-2b54434a84ab4374e99baf5eebf97d92.webp";